import './cards';
import './icon';
import './button';
import './marquee';
import './play-button';
import './list';
import './slider-bullets';
import './accordion';
import './tag';
import './link';
import './dropdown';
import './select';
import './radio';
import './checkbox';
import './filter';
import './pagination';
